import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';

@Injectable()
export class HomepageApiService {
  constructor(
    protected Api: ApiService,
    protected commonFunctionService: CommonFunctionService
  ) {}

  public order(role: string, ProductInfo, categoryId) {
    const endpoint = `${role}/homepage/homepage-order/${categoryId}`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.post(endpoint, ProductInfo, url).then(
      () => this.Api.handleSuccess('Carousel reordered'),
      (error) => this.Api.handleError(error)
    );
  }

  public load(role: string) {
    let endpoint = `${role}/homepage?isAdmin=true`;
    const url = this.commonFunctionService.findApiUrl(role);
    return this.Api.get(endpoint, url).then(
      (data) => {
        return data;
      },
      (error) => this.Api.handleError(error)
    );
  }

  public save(Product, CatId) {
    const { listingId } = Product;
    let endpoint = `admin/homepage/category/${CatId}/listing/${listingId}`;
    const url = this.commonFunctionService.findApiUrl('admin');

    return this.Api.post(endpoint, Product, url).then(
      () => () => this.Api.handleSuccess('Listing added to carousel'),
      (error) => this.Api.handleError(error)
    );
  }

  public updateListingImage(carouselId, image) {
    let endpoint = `admin/homepage/hero-image/${carouselId}`;
    const url = this.commonFunctionService.findApiUrl('admin');

    return this.Api.post(endpoint, image, url).then(
      () => () => this.Api.handleSuccess('Image added to carousel'),
      (error) => this.Api.handleError(error)
    );
  }

  public removeListingImage(carouselId) {
    let endpoint = `admin/homepage/hero-image/${carouselId}`;
    const url = this.commonFunctionService.findApiUrl('admin');

    return this.Api.delete(endpoint, url).then(
      () => () => this.Api.handleSuccess('Image removed from carousel'),
      (error) => this.Api.handleError(error)
    );
  }

  public delete(carouselId) {
    const endpoint = `admin/homepage/carousel/${carouselId}`;
    const url = this.commonFunctionService.findApiUrl('admin');
    return this.Api.delete(endpoint, url).then(
      () => this.Api.handleSuccess(' deleted.'),
      (error) => this.Api.handleError(error)
    );
  }
}
